import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=f4e637ca"
import script from "./CartFooter.ts?vue&type=script&lang=ts&external"
export * from "./CartFooter.ts?vue&type=script&lang=ts&external"
import style0 from "./CartFooter.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports